import api from "../axios";


export const RegisterUser = async (payload) => {
  try {
    const response = await api.post("Auth/Registration",payload);
    return response.data; 
  } catch (error) {
    const message = error.response?.data || "Registration failed. Please try again.";
    throw message;
  }
};

export const LoginUser = async (payload) => {
  try {
    const response = await api.post("Auth/Login",payload);
    return response.data; 
  } catch (error) {
    const message = error.response?.data || "Login failed.";
    throw message;
  }
};

export const ForgotPassword = async (payload) => {
  try {
    const response = await api.post("Auth/ForgetPassword", payload);
    return response.data;
  } catch (error) {
    const message = error.response?.data || "Failed to send reset link.";
    throw message;
  }
};

export const ResetPassword = async (payload) => {
  try {
    const response = await api.post("Auth/ResetPassword", payload);
    return response.data;
  } catch (error) {
    const message = error.response?.data || "Failed to reset password.";
    throw message;
  }
};

export const LoginWithOTP = async (payload) => {
  try {
    const response = await api.post("Auth/LoginWithOTP", payload);
    return response.data;
  } catch (error) {
    const message = error.response?.data || "Login failed.";
    throw message;
  }
};

export const VerifyOTP = async (payload) => {
  try {
    const response = await api.post("Auth/VerifyUserOTP",payload);
    return response.data; 
  } catch (error) {
    const message = error.response?.data || "Login failed.";
    throw message;
  }
};

export const Logout = async (token) => {
  try {
    const response = await api.post("Auth/Logout",{token});
    return response.data; 
  } catch (error) {
    throw error;
  }
};